import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import GameCategorySection from "./cms_game_category";
import useFilterGamesByType from "../../services/helper/filterGamesByType";

const HomeMain = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { staticContent } = useSelector((state) => state?.topGamesList);
  const [gameList, setGameList] = useState([]);
  const filterByGameType = useFilterGamesByType(); 

  useEffect(() => {
    if (Array.isArray(staticContent)) {
      const updatedList = staticContent?.map((item) => ({
        labelName: item.menu_name,
        icons: item.icontags,
        is_active: item.is_active,
      }));
      setGameList(updatedList);
    }
  }, [staticContent]);

  const handleViewAll = (categoryName) => {
    const filteredGames = filterByGameType(categoryName); 
    const gamesList = filteredGames[0]?.game?.length > 0 ? filteredGames[0]?.game : [];
    
    localStorage.setItem('categoryGames', JSON.stringify({
      gamesList,
      categoryName
    }));
    
    navigate(`/games/${categoryName}`, {
      state: {
        gamesList,
        title: categoryName,
        game_type: categoryName
      }
    });
  };

  return (
    <div className="home-container">
      {gameList?.map((item, index) => {
        if (!item.is_active || item.labelName === "Promotions") {
          return null;
        }

        return (
          <GameCategorySection
            key={index}
            categoryName={item.labelName}
            iconName={item.icons}
            maxGames={10}
            onViewAll={handleViewAll}
          />
        );
      })}
    </div>
  );
};

export default HomeMain;
